/*
 * File: AntPageTitle.tsx
 * Project: beaker
 * -----
 * Last Modified: 25 Apr 2022 11:26:30 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Typography } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import { rest } from 'lodash';
import React, { FC } from 'react';
import { InlineStylesModel } from '../../models/InlineStylesModel';

const styles: InlineStylesModel = {
  title: {
    margin: 0,
    fontWeight: 'normal'
  }
};

interface ExtendedTitleProps extends TitleProps {
  text: string;
}

export const AntPageTitle: FC<ExtendedTitleProps> = (props: ExtendedTitleProps) => {
  return (
    <Typography.Title {...rest} level={4} style={styles.title}>
      {props.text}
    </Typography.Title>
  );
};
